import { useSelector } from 'react-redux'
import {
  selectOfficeAddress,
  selectOfficeName,
  selectShowOfficeAddress,
} from 'src/store/selectors/customerProfile'
import { Text } from 'src/Components'
import styles from './OfficeInfo.module.scss'

const OfficeInfo = () => {
  const officeName = useSelector(selectOfficeName)
  const address = useSelector(selectOfficeAddress) || {}
  const showOfficeAddress = useSelector(selectShowOfficeAddress)

  const { city, state, street, zipCode } = address

  const fullOfficeAddressPresent = Object.values(address).every(
    val => Boolean(val) === true
  )

  return (
    <div className={styles.container}>
      {officeName && (
        <Text
          variant='neutralCool'
          variantCount='800'
          size='xs'
          weight='semibold'
        >
          {officeName}
        </Text>
      )}
      {showOfficeAddress && fullOfficeAddressPresent && (
        <div className={styles.address}>
          <Text variant='neutralCool' variantCount='700' size='xs'>
            {street}
          </Text>
          <Text variant='neutralCool' variantCount='700' size='xs'>
            {city}, {state} {zipCode}
          </Text>
        </div>
      )}
      <hr />
    </div>
  )
}

export default OfficeInfo
